import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { storageKeys } from '@config'

// Store d'authentification
export const useAuthStore = create(
  devtools(
    persist(
      (set, get) => ({
        // État
        user: null,
        token: null,
        userType: null, // 'admin' | 'client'
        isAuthenticated: false,
        isLoading: false,

        // Actions
        setUser: (user) => set({ user, isAuthenticated: !!user }),
        
        setToken: (token) => {
          set({ token })
          if (token) {
            localStorage.setItem(storageKeys.authToken, token)
          } else {
            localStorage.removeItem(storageKeys.authToken)
          }
        },

        login: (user, token, userType = 'client') => {
          set({ user, token, userType, isAuthenticated: true })
          localStorage.setItem(storageKeys.authToken, token)
        },

        logout: async () => {
          const { token } = get()

          if (token) {
            try {
              const { apiConfig } = await import('@config')
              await fetch(`${apiConfig.baseURL}/logout`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': `Bearer ${token}`,
                },
              })
            } catch (error) {
              console.error('Erreur lors de la déconnexion côté serveur:', error)
            }
          }

          set({ user: null, token: null, userType: null, isAuthenticated: false })
          localStorage.removeItem(storageKeys.authToken)
          localStorage.removeItem(storageKeys.refreshToken)
          localStorage.removeItem('rememberMe')
        },

        updateUser: (userData) => {
          set((state) => ({
            user: { ...state.user, ...userData },
          }))
        },

        setLoading: (isLoading) => set({ isLoading }),
      }),
      {
        name: 'auth-storage',
        partialize: (state) => ({
          user: state.user,
          token: state.token,
          userType: state.userType,
          isAuthenticated: state.isAuthenticated,
        }),
      }
    )
  )
)

export default useAuthStore
